import { render, staticRenderFns } from "./edit-preferential.vue?vue&type=template&id=5cc2e783&"
import script from "./edit-preferential.vue?vue&type=script&lang=ts&"
export * from "./edit-preferential.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-preferential.vue"
export default component.exports